export default "__VITE_ASSET__DzUBxqVD__"